import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectAreas } from "../../../../../../../../../redux/features/quotes/quote-create-advanced/selectors/sectorWorkflowSelectors";
import { quoteCreateActions } from "../../../../../../../../../redux/features/quotes/quote-create-advanced";



export const useAreaActions = () => {
  const dispatch = useDispatch();
  const areas = useSelector(selectAreas);
  const { initializeAreasFromBackend, changeAreaQuantity, toggleAreaTaskActive } = quoteCreateActions


  const initialize = useCallback(
    (backendAreas) => {
      dispatch(initializeAreasFromBackend(backendAreas));
    },
    [dispatch]
  );

  const changeQuantity = useCallback(
    (areaUid, delta) => {
      dispatch(changeAreaQuantity({ areaUid, delta }));
    },
    [dispatch]
  );

  const toggleTask = useCallback(
    (areaUid, taskUid) => {
      dispatch(
        toggleAreaTaskActive({
          areaUid,
          taskUid: String(taskUid),
        })
      );
    },
    [dispatch]
  );

  return {
    areas,
    initialize,
    changeQuantity,
    toggleTask,
  };
};
